import Spinner from "vue-simple-spinner";
import Vue from "vue";
import ToggleButton from "vue-js-toggle-button";
import UptimeAPIHandler from "../lib/UptimeAPIHandler";
import NameSiloAPIHandler from "../lib/NameSiloAPIHandler";
import { mapState } from 'vuex'

Vue.use(ToggleButton);

export default {
	// mixins: [UptimeAPIHandler, NameSiloAPIHandler],
	components: {
		Spinner
	},
	props: ["site", "servers", "registries"],

	computed: {
		// monitor_http: {
		// 	// getter
		// 	get: function() {
		// 		return this.site.M_MONITOR_HTTP != "0";
		// 	},
		// 	set: function(newValue) {
		// 		var nv = newValue ? "1" : "0";
		// 		this.site.M_MONITOR_HTTP = nv;
		// 	}
		// },
		...mapState({
			// arrow functions can make the code very succinct!
			userdata: state => state.auth.userdata
		})
	},


	data() {
		return {
			monitor_http: this.site.M_MONITOR_HTTP != '0',
			working: false,
			editable: (this.$hasOneOfRoles(['websites/add', 'websites/edit'])) ? "" : "disabled",
			renewclass: "",
			haswp: [
				{ 'value': "0", 'text': "No" },
				{ 'value': "1", 'text': "Yes" },
			],

			intstatuses: [
				{ 'value': "0", 'text': "Not ready" },
				{ 'value': "1", 'text': "Prepared" },
				{ 'value': "2", 'text': "In Progress" },
				{ 'value': "3", 'text': "Ready" }
			],
			activeselecter: [
				{ 'value': "0", 'text': "Inactive" },
				{ 'value': "1", 'text': "Active" },
				{ 'value': "2", 'text': "Unreachable/Wrong WP Account" },
			],
			systems: [
				{ 'value': "hestia", 'text': "Hestia" }
			],
			cf_vorlage: {
				'agathe': { 'value': "agathe", 'text': "Agathe Lasch", "cf_user": "agathe.lasch@premium.email-pool.de" },
				'anatolikos': { 'value': "anatolikos", 'text': "Anatolikos", "cf_user": "anatolikos@13bit.de" },
				'anton': { 'value': "anton", 'text': "Anton Nott", "cf_user": "anton.nott@premium.email-pool.de" },
				'beaverpony': { 'value': "beaverpony", 'text': "Beaverpony", "cf_user": "beaverpony@premium.email-pool.de" },
				'carl.sock': { 'value': "carl.sock", 'text': "Carl Sock", "cf_user": "carl.sock@premium.email-pool.de" },
				'costas': { 'value': "costas", 'text': "Costas", "cf_user": "costas@13bit" },
				'fluffy': { 'value': "fluffy", 'text': "Fluffy", "cf_user": "fluffy@premium.email-pool.de" },
				'mousseguru': { 'value': "mousseguru", 'text': "Mousseguru", "cf_user": "mousseguru@premium.email-pool.de" },
				'notwist': { 'value': "notwist", 'text': "Notwist", "cf_user": "notwist@premium.email-pool.de" },
				'pete': { 'value': "pete", 'text': "Pete", "cf_user": "pete.bondurant@premium.email-pool.de" },
				'willy': { 'value': "willy", 'text': "Willy", "cf_user": "willy@premium.email-pool.de" },
				'sharex': { 'value': "sharex", 'text': "ShareX", "cf_user": "sharex@13bit.de" }
			},
			dummycf: [
				{ 'value': "-", 'text': "----", "cf_user": "" },
				{ 'value': "agathe", 'text': "Agathe Lasch", "cf_user": "agathe.lasch@premium.email-pool.de" },
				{ 'value': "anatolikos", 'text': "Anatolikos", "cf_user": "anatolikos@13bit.de" },
				{ 'value': "anton", 'text': "Anton Nott", "cf_user": "anton.nott@premium.email-pool.de" },
				{ 'value': "beaverpony", 'text': "Beaverpony", "cf_user": "beaverpony@premium.email-pool.de" },
				{ 'value': "carl.sock", 'text': "Carl Sock", "cf_user": "carl.sock@premium.email-pool.de" },
				{ 'value': "costas", 'text': "Costas", "cf_user": "costas@13bit" },
				{ 'value': "fluffy", 'text': "Fluffy", "cf_user": "fluffy@premium.email-pool.de" },
				{ 'value': "mousseguru", 'text': "Mousseguru", "cf_user": "mousseguru@premium.email-pool.de" },
				{ 'value': "notwist", 'text': "Notwist", "cf_user": "notwist@premium.email-pool.de" },
				{ 'value': "pete", 'text': "Pete", "cf_user": "pete.bondurant@premium.email-pool.de" },
				{ 'value': "willy", 'text': "Willy", "cf_user": "willy@premium.email-pool.de" },
				{ 'value': "sharex", 'text': "ShareX", "cf_user": "sharex@13bit.de" }
			],
			cfaccounts: [],
			panelpasswds: {
				'hestia': 'Hu_dd@39BYu1Mzk623'
			},
			dbconnstring: `'mysql:host=localhost;dbname=${this.site.M_DB_NAME}', '${this.site.M_DB_USER}', '${this.site.M_DB_PWD}'`

		};
	},
	mounted: function () {
		if (this.$hasOneOfRoles(['keywordserver/add', 'keywordserver/edit', 'websites/add', 'websites/edit'])) {
			this.editable = false
			console.log("kannich")
		}
		this.cfaccounts = this.dummycf;
		this.startCF()

	},
	methods: {
		assertDelete() {
			if (confirm("Are you sure you want to remove this 301 Site?")) {
				this.onChangeMonitor('db', 'delete')
				this.$emit("deleteItem", this.site.M_ID);
			}
		},

		async startCF() {
			await this.getCfAccounts()
		},

		async getCfAccounts() {
			let that = this
			let newcf = []
			console.log("get cf")
			try {
				const resp = await this.$http.get("/websites/cloudflareaccounts", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') } });
				if(!resp.data.accounts) {
					alert("no cf accounts found")
				}
				else if (resp.data.error) {
					alert("Connection failed: " + resp.data.error)
					//resolve({'loginError':resp.data.error})
				}
				else {
					for (let x in resp.data.accounts) {
						console.log("CF Accounts", resp.data.accounts[x])
						// newcf.push({ ...resp.data[x], ...that.cf_vorlage[x] });
						newcf.push({ ...resp.data.accounts[x] });
					}
					this.cfaccounts = newcf
				}
			}
			catch(err) {
					// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
					alert(err)
			}
		},

		async onChangeMonitor(what, force_status) {
			// console.log("Now its ", this.site.M_MONITOR_HTTP);
			let fieldname = "monitor_" + what;
			// console.log("VALUE ", this.monitor_http)
			// console.log("unsetting monitor ", fieldname, " to ", force_status);
			let val = this[fieldname];
			let senddata = this.site;
			senddata.table = "SERVER";
			senddata.type = what;
			if (force_status) {
				senddata.action = force_status;
			}
			else {
				senddata.action = senddata.M_MONITOR_HTTP != '0' ? "delete" : "add";
			}
			try {
				if (!senddata.M_WP_URL || senddata.M_WP_URL == '') {
					alert("No URL available for this domain: ")
					return false
				}
				var headers = {
					headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
				}
				let that = this;
				this.$http.post("/monitors/set", senddata, headers)
					.then(function (response) {
						let msg = (senddata.action == "add") ? "Added" : "Deleted"
						let typefieldname = senddata.type.toUpperCase()
						typefieldname = 'M_MONITOR_' + typefieldname
						let id = response.id;
						// this[typefieldname] = id
						if (response.data.Error) {
							that.$toastr.Add({
								title: "ERROR", // Toast Title
								msg: response.data.Error,
								position: "toast-top-center",
								type: "error"
							});
							that.monitor_http = !that.monitor_http
							return "X"
						}
						else {
							that.$toastr.Add({
								title: "Success", // Toast Title
								msg: msg + " monitor",
								position: "toast-top-center",
								type: "success"
							});
							return "Y"
						}
						// console.log(response)

					})
					.catch(function (error) {
						console.log(error)
						that.$toastr.e("Error", error);
						that.monitor_http = !that.monitor_http
						return "ERR";
					})


				// let antw = await this.setUptimeMonitor(senddata);
				// console.log("The ", antw)

			}
			catch (e) {
				this.$toastr.e("Error", e.getMessage());
			}

			console.log("Now its ", this.site.M_MONITOR_HTTP);
		},


		restoreDomain() {
			let that = this;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.get('/websites/restore/' + this.site.M_DOMAIN, headers)
				.then(function (response) {
					if (response.data.ERROR) {
						that.$toastr.Add({
							title: "Error", // Toast Title
							msg: response.data.ERROR,
							position: "toast-top-center",
							type: "error"
						});
					}
					else {
						let data = JSON.parse(response.data)
						console.log(data)
						const udfields = [
							'M_BACKUP_AGE', 'M_BACKUP_FILENAME',
							'M_CLOUDFLAREACCOUNT', 'M_FTP_PWD', 'M_FTP_USER',
							'M_OTHER', 'M_REMARKS', 'M_WP_PWD',
							'M_WP_URL', 'M_WP_USER'
						]
						for (let i = 0; i < udfields.length; i++) {
							that.site[udfields[i]] = data[udfields[i]]
						}
						that.site.M_OTHER += "\nOld data on " + data.M_BASEIP;


						that.$toastr.Add({
							title: "Success", // Toast Title
							msg: "Update successful\n",
							position: "toast-top-center",
							type: "success"
						});
					}
				})
			// .catch(function (error) {
			// 	alert("There was an error processing your request.", error)
			// 	console.log(error)
			// })
			// .catch(function (error) {
			// 	alert("There was an error processing your request.", error)
			// 	console.log(error)
			// })
		},

		transmitForm() {
			var fields = [
				"M_ID",
				"M_RID",
				"M_ACTIVE",
				"M_DOMAIN",
				"M_INT_STATUS",
				"M_PROVIDER",
				"M_BASEIP",
				"M_FTP_USER",
				"M_FTP_PWD",
				"M_WP_USER",
				"M_WP_PWD",
				"M_WP_URL",
				"M_HASWP",
				"M_SSH_USER",
				"M_SSH_PWD",
				"M_DB_NAME",
				"M_DB_USER",
				"M_DB_PWD",
				"M_PANEL_ADDRESS",
				"M_PANEL_USER",
				"M_PANEL_PWD",
				"M_OTHER",
				"M_SHORTNOTE",
				"M_SERVERSYS",
				"M_CLOUDFLAREACCOUNT"
			];
			let transfer = {};
			for (var i = 0; i < fields.length; i++) {
				transfer[fields[i]] = this.site[fields[i]];
			}
			this.$emit("updateItem", transfer);
		},
		makeClicker() {
			let hestiaextra = ''
			console.log(this.site.M_SERVERSYS + "!")
			if (this.site.M_SERVERSYS == 'hestia') hestiaextra = " --servertype=hestia"
			let inst_extra = ''
			let ppt = this.site.M_DOMAIN.split(".")
			if (ppt.length > 2) inst_extra = ' --todo domain'
			let str =
				'$domain = "' +
				this.site.M_DOMAIN +
				'";\n\
$ip = "' +
				this.site.M_BASEIP +
				'";\n\
$user = "' +
				this.site.M_FTP_USER +
				'";\n\
$wpuser = "' +
				this.site.M_WP_USER +
				'";\n\
$wppwd = "' +
				this.site.M_WP_PWD +
				'";\n'

			if (this.site.M_DB_NAME != '') {
				str += "\n" + '$dbname = "' +
					this.site.M_DB_NAME +
					'";\n\
$dbuser = "' +
					this.site.M_DB_USER +
					'";\n\
$dbpwd = "' +
					this.site.M_DB_PWD +
					'";\n'


			}

			// let dnsservice = "namecheapdns";
			let dnsservice = "correct_nameservers";
			if (this.site.M_RID == 63) {
				dnsservice = "netimdns";
			}

			if (this.site.M_TYPE == '301') {
				str += '/*\n'
				str += "rsync -ua 301-hestia_installer root@" +
					this.site.M_BASEIP +
					":~/ && ssh root@" +
					this.site.M_BASEIP +
					"  \"bash --login -c './301-hestia_installer/install.php --todo nossl'\"\n\n";
				str += "./cloudflare/set.php --ip=" +
					this.site.M_BASEIP +
					" --cfaccount=" + this.site.M_CLOUDFLAREACCOUNT + " --domain=" + this.site.M_DOMAIN + " && ./cloudflare/set.php --todo=" + dnsservice + " --cfaccount=" + this.site.M_CLOUDFLAREACCOUNT + " --ip=" +
					this.site.M_BASEIP +
					" --domain=" + this.site.M_DOMAIN + "\n\n\
./cloudflare/set.php --ip=" +
					this.site.M_BASEIP +
					" --cfaccount=" + this.site.M_CLOUDFLAREACCOUNT + " --domain=" + this.site.M_DOMAIN + " --todo=allCert --user=" + this.site.M_FTP_USER + hestiaextra + "\n*/\n";
			}
			const el = document.createElement("textarea");
			el.value = str;
			document.body.appendChild(el);
			el.select();
			var successful = document.execCommand("copy");
			var msg = successful ? "successful" : "unsuccessful";
			document.body.removeChild(el);
			// console.log(msg);
		},


		removeSite(entry) {
			var that = this
			this.working = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/websites/removesite', { M_ID: this.site.M_ID }, headers)
				.then(function (response) {
					if (response.data.Error) {
						that.$toastr.Add({
							title: "Error", // Toast Title
							msg: response.data.Error,
							position: "toast-top-center",
							type: "error"
						});
					}
					that.working = false;
					that.showeditor = false;
					that.$toastr.Add({
						title: "Success", // Toast Title
						msg: "Update successful\n",
						position: "toast-top-center",
						type: "success"
					});
					that.site.M_OTHER += response.data.zoneid
					console.log(response)
				})
				.catch(function (error) {
					that.working = false;
					alert("There was an error processing your request.", error)
					that.showeditor = false;
					console.log(error)
				})
			// alert(entry.s_id + "!!")
		},


		setStuff() {
			let ftpres = this.makePassword(24)
			this.site.M_FTP_PWD = ftpres;
			this.site.M_WP_PWD = ftpres;
			this.site.M_WP_URL = "https://www." + this.site.M_DOMAIN;
			let parts = this.site.M_DOMAIN.split(".");
			this.site.M_FTP_USER = parts[0].replace(/[^a-z0-9]/i, "").substring(0, 14);
			this.site.M_WP_USER = parts[0].charAt(0).toUpperCase() + parts[0].slice(1);
			this.site.M_HASWP = 1;
		},

		makePassword(length) {
			let chars =
				"0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
			let result = "";
			for (let i = length; i > 0; --i)
				result += chars[Math.floor(Math.random() * chars.length)];
			return result;
		},

		setDatabase() {
			let dbres = this.makePassword(24)
			this.site.M_DB_PWD = dbres;
			let dbnamesuffix = this.makePassword(2).toLowerCase();
			let dbusersuffix = this.makePassword(2).toLowerCase();
			this.site.M_DB_NAME = `${this.site.M_FTP_USER}_${dbnamesuffix}`;
			this.site.M_DB_USER = `${this.site.M_FTP_USER}_${dbusersuffix}`;
			this.dbconnstring = `'mysql:host=localhost;dbname=${this.site.M_DB_NAME}', '${this.site.M_DB_USER}', '${this.site.M_DB_PWD}'`
		},

		makeDBSetupClicker() {
			this.setDatabase();
			let h_dbname = this.site.M_DB_NAME.replace(this.site.M_FTP_USER + "_", "");
			let h_dbuser = this.site.M_DB_USER.replace(this.site.M_FTP_USER + "_", "");
			let str = "ssh root@" +
				this.site.M_BASEIP +
				" '/usr/local/hestia/bin/v-add-database " + this.site.M_FTP_USER +
				" " + h_dbname + " " + h_dbuser + " " + this.site.M_DB_PWD + "'";

			const el = document.createElement("textarea");
			el.value = str;
			document.body.appendChild(el);
			el.select();
			var successful = document.execCommand("copy");
			var msg = successful ? "successful" : "unsuccessful";
			document.body.removeChild(el);

		},

		makeDBClicker() {
			if (!this.dbconnstring || this.dbconnstring == '') {
				this.$toastr.e("Error", "No DB data available");
				return false;
			}
			const el = document.createElement("textarea");
			el.value = this.dbconnstring;
			document.body.appendChild(el);
			el.select();
			var successful = document.execCommand("copy");
			var msg = successful ? "successful" : "unsuccessful";
			document.body.removeChild(el);

		},

		makeFTPClicker() {
			let str = `ftp://${this.site.M_FTP_USER}:${this.site.M_FTP_PWD}@${this.site.M_BASEIP}/home/${this.site.M_FTP_USER}/web/${this.site.M_DOMAIN}/public_html/`
			const el = document.createElement("textarea");
			el.value = str;
			document.body.appendChild(el);
			el.select();
			var successful = document.execCommand("copy");
			var msg = successful ? "successful" : "unsuccessful";
			document.body.removeChild(el);

		},

		makeWPClicker() {
			let str = `${this.site.M_WP_USER}//${this.site.M_WP_PWD}`
			const el = document.createElement("textarea");
			el.value = str;
			document.body.appendChild(el);
			el.select();
			var successful = document.execCommand("copy");
			var msg = successful ? "successful" : "unsuccessful";
			document.body.removeChild(el);

		},


		setInitialStuff() {
			this.setStuff();
			this.setDatabase();
			this.onChangeMonitor('http', 'add');
			this.site.M_INT_STATUS = 3;
			this.makeClicker();
		},

		async resetDomain() {
			if (this.site.M_MONITOR_HTTP != '0') {
				await this.onChangeMonitor('http', 'delete');
			}
			this.site.M_DOMAIN = '----';
			this.site.M_RID = '41';
			this.site.M_FTP_USER = '';
			this.site.M_FTP_PWD = '';
			this.site.M_DB_USER = '';
			this.site.M_DB_PWD = '';
			this.site.M_DB_NAME = '';
			this.site.M_WP_URL = '';
			this.site.M_WP_USER = '';
			this.site.M_WP_PWD = '';
			this.site.M_OTHER = '';
			this.site.M_INT_STATUS = 1
			this.monitor_http = false
			this.monitor_db = false
		},


		switchpwd() {
			if (this.site.M_SERVERSYS != '') {
				console.log(this.site.M_SERVERSYS);
				this.site.M_PANEL_PWD = this.panelpasswds[this.site.M_SERVERSYS]
			}
		}
	}
};
